export const CALENDAR_SELECTIONS_SESSION_STORAGE_KEY = 'calendarSelections';
export const storeCalendarSelections = _ref => {
  let {
    calendarSelections,
    session
  } = _ref;
  session.setItem(CALENDAR_SELECTIONS_SESSION_STORAGE_KEY, JSON.stringify(calendarSelections));
  return;
};
export const cleanCalendarSelections = _ref2 => {
  let {
    session
  } = _ref2;
  session.removeItem(CALENDAR_SELECTIONS_SESSION_STORAGE_KEY);
};
//# sourceMappingURL=storeCalendarSelections.js.map